import * as React from "react";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";

export interface IProcessLeftbarProps extends React.Props<ProcessLeftbar> {
    onSave?: () => void;
    onCancel: () => void;
    isActive: boolean;
    onPosting?: boolean;
}

export interface IProcessLeftbarState {}

export class ProcessLeftbar extends BaseComponent<IProcessLeftbarProps, IProcessLeftbarState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { onPosting, isActive } = this.props;
        return (
            <div role="navigation" aria-label="Action buttons" className="layout-process-leftbar no-print">
                {this.props.onSave && (
                    <a className="process-control-primary" onClick={onPosting ? null : () => this.props.onSave()} role="button" href="#">
                        {isActive ? "Save & exit" : "Back to dashboard"}
                    </a>
                )}
                {this.props.onCancel && isActive && (
                    <a className="process-control-secondary" onClick={onPosting ? null : this.props.onCancel} role="button" href="#">
                        Cancel
                    </a>
                )}
            </div>
        );
    }
}
